import moment from 'moment';
import leadsAPI from '@/api/leads';
import telcoLinesAPI from '@/api/telco/lines';

const state = () => ({
  telcoLinesCliHistories: [],
  telcoLinesCliHistoriesLoading: false,
  telcoCliChangeReasons: [],
  telcoCliChangeReasonsLoading: false,
  telcoCreateAddressLoading: false,
  telcoCreateAddressError: false,
});

const mutations = {
  setTelcoLinesCliHistories(state,data){
    state.telcoLinesCliHistories = data;
  },
  setTelcoLinesCliHistoriesLoading(state,data){
    state.telcoLinesCliHistoriesLoading = data;
  },
  setTelcoCliChangeReasons(state, data) {
    state.telcoCliChangeReasons = data;
  },
  setTelcoCliChangeReasonsLoading(state, data) {
    state.telcoCliChangeReasonsLoading = data;
  },
  setTelcoCreateAddressLoading(state, data) {
    state.telcoCreateAddressLoading = data;
  },
  setTelcoCreateAddressError(state, data) {
    state.telcoCreateAddressError = data;
  }
};

const actions = {
  async fetchTelcoLinesCliHistories({commit,dispatch}, {productId, opts}){
    commit('setTelcoLinesCliHistoriesLoading',true);
    try{
      const res = await telcoLinesAPI.fetchCliHistories(productId, opts);
      if(res.status===200){
        commit('setTelcoLinesCliHistories',res.data);
      }else{
        setAlertByResErr(dispatch, res);
      }
    }catch(err){
      setAlertByResErr(dispatch, err);
    }
    commit('setTelcoLinesCliHistoriesLoading',false);
  },

  async changeCli({ dispatch }, { productId, data }) {
    try {
      await telcoLinesAPI.changeCli(productId, data);
      setAlert(dispatch, {
        type: 'success',
        message: 'Cli changed successfully'});
    } catch(err) {
      setAlertByResErr(dispatch, err);
      throw err;
    }
  },
  getTelcoCliChangeReasons({ commit }) {
    commit('setTelcoCliChangeReasonsLoading', true);
    return leadsAPI
      .getLeadStaticData({object_kind: 'CLIHistory', field: 'telco_cli_change_reason'})
      .then(res => {
        commit('setTelcoCliChangeReasons', res.data);
      })
      .catch(() => {
        commit('setTelcoCliChangeReasons', []);
      })
      .finally(() => {
        commit('setTelcoCliChangeReasonsLoading', false);
      });
  },
  async createNewAddress({ commit, dispatch }, { product_id }) {
    commit('setTelcoCreateAddressLoading', true);
    commit('setTelcoCreateAddressError', false);
    try {
      await telcoLinesAPI.createNewAddress(product_id);
      commit('setTelcoCreateAddressLoading', false);
      setAlert(dispatch, {
        type: 'success',
        message: 'Address Created'});
    }catch(err) {
      commit('setTelcoCreateAddressLoading', false);
      commit('setTelcoCreateAddressError', true);

      setAlertByResErr(dispatch, err, "Creating address failed: ");
    }
  }
};

const
  setAlertByResErr = (dispatch, obj, appendMsg = "") => {
    let response = obj.response || {},
      data = response.data || {};
    setAlert(dispatch, {
      type: 'error',
      message: `${appendMsg}${data.message}` || 'Please try again. Raise it if the issue persists'
    });
  },
  setAlert = (dispatch, data) => {
    dispatch("alerts/setAlert", data, { root: true });
  };

const getters = {
  getTelcoLinesCliHistories: (state)=>{
    return state.telcoLinesCliHistories.map(e=>{
      return {
        ...e,
        timestampFormatted: moment(e.last_changed).format('YYYY/MM/DD HH:mm')
      }
    });
  },
  getTelcoCreateAddressLoading: state => state.telcoCreateAddressLoading,
  getTelcoCreateAddressError: state => state.telcoCreateAddressError
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
